import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../Translations';
import EmptyLearningCollectionIcon from '../../Cutesies/EmptyLearningCollection';

interface Props {}

const LearningCollectionsEmpty: React.FC<Props> = () => {
  return (
    <div
      className={clsx(
        'rounded-md border-2 border-dashed border-gray-400',
        'bg-gray-50 py-12 px-1 text-center md:px-0',
      )}
    >
      <div className="inline-block w-full md:w-2/5">
        <EmptyLearningCollectionIcon />
      </div>
      <p className="mt-9 text-lg font-bold text-gray-500">
        <T kind="Get started by adding your first Learning Collection" />
      </p>
      <p className="text-base text-gray-500 max-w-full inline-block text-center w-3/5 lg:w-3/5 break-words">
        <T kind="Learning Collections are curated sets of experiences ..." />
      </p>
    </div>
  );
};

export default observer(LearningCollectionsEmpty);
